module.exports = __webpack_public_path__ + "img/VR展馆页面-头图.f55c5f45.jpg";